import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';

export const selectGameStatus = (state: RootState) => state.game.gameStatus;
export const selectCaseData = (state: RootState) => state.game.caseData;
export const selectError = (state: RootState) => state.game.error;
export const selectLoadingMessage = (state: RootState) =>
  state.game.loadingMessage;

export const selectGameStartTime = (state: RootState) =>
  state.game.gameStartTime;

// Locations
export const selectCurrentLocationIndex = (state: RootState) =>
  state.game.currentLocationIndex;
export const selectCurrentLocation = createSelector(
  [selectCaseData, selectCurrentLocationIndex],
  (caseData, currentLocationIndex) => {
    if (!caseData || !caseData.locations || caseData.locations.length === 0) {
      return null;
    }

    if (currentLocationIndex >= caseData.locations.length) {
      return null;
    }

    return caseData.locations[currentLocationIndex];
  },
);

// Scenes
export const selectCurrentSceneIndex = (state: RootState) =>
  state.game.currentSceneIndex;
export const selectCurrentScene = createSelector(
  [(state) => selectCurrentLocation(state), selectCurrentSceneIndex],
  (location, sceneIndex) => location?.scenes?.[sceneIndex],
);

export const selectHasMultipleScenes = createSelector(
  [selectCurrentLocation],
  (location) => (location?.scenes?.length ?? 0) > 1,
);

export const selectPendingSceneNavigation = (state: RootState) =>
  state.game.pendingSceneNavigation;

export const selectEvidenceBucket = (state: RootState) =>
  state.game.evidenceBucket;

export const selectFoundItems = (state: RootState) => state.game.foundItems;
export const selectWrongClicks = (state: RootState) => state.game.wrongClicks;
export const selectWrongClickTimestamps = (state: RootState) =>
  state.game.wrongClickTimestamps;

// Tutorial and UI selectors
export const selectHasSeenSwipeTutorial = (state: RootState) =>
  state.game.hasSeenSwipeTutorial;

export const selectIsAllEvidenceFound = createSelector(
  [selectEvidenceBucket],
  (evidenceBucket) => {
    if (!evidenceBucket) return false;
    return (
      evidenceBucket.foundEvidence.length === evidenceBucket.evidence.length
    );
  },
);

export const selectFoundEvidence = createSelector(
  [selectEvidenceBucket],
  (evidenceBucket) => {
    return evidenceBucket?.foundEvidence || [];
  },
);

export const selectAllEvidence = createSelector(
  [selectEvidenceBucket],
  (evidenceBucket) => {
    return evidenceBucket?.evidence || [];
  },
);
